import React from "react";
import styled from 'styled-components';
import ColumnsLayout from "../layouts/columns-layout";
import Column from "../layouts/column";
import {ThemeProvider} from "styled-components";
import {useThemes} from "../style/themes.hook";
import {Helmet} from "react-helmet";
import SEO from "../components/seo";
// import ShutterSVG from "../../static/svg/shutter.svg";

const OveIframe = styled.div`
  display: flex;
  justify-content: center;
`;

// const Loader = styled(ShutterSVG)`
//   width: 10vw;
//   height: auto;
//   position: absolute;
//   display: flex;
//   justify-content: center;
//   align-self: center;
//
//   path {
//     fill: #FF72F6;
//   }
// `;

class BuyPage extends React.Component {
  componentDidMount() {
  }

  render() {
    const themes = useThemes();

    return (
      <>
        <SEO
          title={`Cumpără Bilet`}
          description={`Mai ai un pas pentru a-ți cumpăra biletul la Imagine Timisoara Festival.`}
        />
        <Helmet>
          <script src={"/scripts/ove-iframe.js"}/>
        </Helmet>
        <ThemeProvider theme={themes.light}>
            <ColumnsLayout page="buy-ticket">
              <Column heading="Cumpără Bilet">
                <OveIframe className="ove-iframe">
                  {/*<Loader className="ove-loader"/>*/}
                </OveIframe>
              </Column>
            </ColumnsLayout>
        </ThemeProvider>
      </>
    );
  }
}

export default BuyPage;